import { apiJson } from "./client";
import { clearCart } from "../cart/db";
import { socketClient } from "./socket";

export const IMPERSONATION_KEY = "dwik:impersonation";
export interface ImpersonationNotice { username: string; expires_at: number; session_id: string }

export function readImpersonation(): ImpersonationNotice | null {
  try {
    const value = JSON.parse(localStorage.getItem(IMPERSONATION_KEY) || "null");
    return value && typeof value.username === "string" && typeof value.session_id === "string"
      && typeof value.expires_at === "number" ? value : null;
  }
  catch { return null; }
}

async function reloadIdentity(route: string) {
  socketClient.close();
  // Local artwork/address edits must never carry over between identities.
  try { await clearCart(); } catch (error) { console.error("Could not clear local cart", error); }
  sessionStorage.removeItem("postLoginRedirect");
  window.location.hash = route;
  window.location.reload();
}

export async function startImpersonation(userId: number) {
  const result = await apiJson<ImpersonationNotice>(`/admin/users/${userId}/impersonate`, { method: "POST" });
  localStorage.setItem(IMPERSONATION_KEY, JSON.stringify(result));
  await reloadIdentity("/cart");
}

export async function stopImpersonation() {
  await apiJson("/auth/impersonation/stop", { method: "POST" });
  localStorage.removeItem(IMPERSONATION_KEY);
  await reloadIdentity("/admin/users");
}
